// extracted by mini-css-extract-plugin
export default {"submit":"TmoForm_submit__MupzK"};